import type { NavLinkProps } from 'react-router-dom'

import { useMeQuery } from '../../../store/api'
import ReloaderNavlink from '../reloader-navlink'

export default function DashboardLink({ onClick, ...props }: NavLinkProps) {
  const { data } = useMeQuery()

  const { children, className } = props

  if (data && !data.has_tracker) {
    return (
      <>
        <div
          data-tooltip-id="dashboard-menu-tooltip"
          data-tooltip-content="You need to add one product and one url."
          data-tooltip-place="right"
          className={`${className as string} cursor-pointer`}
          onClick={(e) => e.preventDefault()}
        >
          {(children as Function)?.({ isActive: false })}
        </div>
      </>
    )
  }
  return <ReloaderNavlink onClick={onClick} {...props} />
}
